<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>Student List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      color="info"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('students.download-report', { ...filters })"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left>
                        mdi-cloud-download
                      </v-icon>
                      Download Excel
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('students.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">ID</div>
                      <v-text-field
                        v-model="filters.code"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="ID"
                        hide-details
                        dense
                        clearable
                        @blur="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Name</div>
                      <v-text-field
                        v-model="filters.name"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Name"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Status</div>
                      <v-select
                        v-model="filters.status"
                        :items="statusOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Status"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Teacher</div>
                      <v-autocomplete
                        v-model="filters.private_teacher_id"
                        :items="privateTeachers"
                        :loading="isPrivateTeachersLoading"
                        :search-input.sync="searchInputPrivateTeacher"
                        item-text="name"
                        item-value="id"
                        solo
                        flat
                        outlined
                        dense
                        placeholder="Choose private teacher"
                        cache-items
                        hide-details
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Registration date</div>
                      <date-picker
                        v-model="filters.registration_date"
                        value-type="format"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Inactive date</div>
                      <date-picker
                        v-model="filters.inactive_date"
                        value-type="format"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Birth date</div>
                      <date-picker
                        v-model="filters.date_of_birth"
                        value-type="format"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Gender</div>
                      <v-select
                        v-model="filters.gender"
                        :items="genderOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Gender"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Created At</div>
                      <date-picker
                        v-model="filters.created_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Updated At</div>
                      <date-picker
                        v-model="filters.updated_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.code`]="{ item }">
            <strong>{{ item.code }}</strong>
          </template>
          <template #[`item.date_of_birth`]="{ item }">
            {{ formatDate(item.date_of_birth, 'DD MMM YYYY') }}
          </template>
          <!-- <template #[`item.gender`]="{ item }">
            {{ genderProps(item.gender, 'text') }}
          </template> -->
          <template #[`item.enrollment`]="{ item }">
            {{ item.current_lesson_plan ? item.current_lesson_plan.name : '-' }}
          </template>
          <template #[`item.registration_date`]="{ item }">
            {{ formatDate(item.registration_date, 'DD MMM YYYY') }}
          </template>
          <template #[`item.private_teachers`]="{ item }">
            <ul v-if="item.private_teachings.length > 0">
              <li
                v-for="privateTeaching in item.private_teachings"
                :key="privateTeaching.id"
              >
                {{ privateTeaching.teacher.name }}
              </li>
            </ul>
            <div v-else>-</div>
          </template>
          <template #[`item.status`]="{ item }">
            <div class="d-flex flex-column justify-center align-center">
              <v-chip
                :color="studentStatusProps(item.status, 'color')"
                small
                dark
              >
                <strong>
                  {{ studentStatusProps(item.status, 'text') }}
                </strong>
              </v-chip>
              <div v-if="item.status === 'INACTIVE' && !!item.inactive_date">
                <div class="text-caption">
                  {{ formatDate(item.inactive_date, 'DD MMM YYYY') }}
                </div>
              </div>
            </div>
          </template>
          <template #[`item.action`]="{ item }">
            <v-menu offset-y>
              <template #activator="{ on, attrs }">
                <v-btn icon color="gray" v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <template v-for="(action, i) in generateRowActions(item)">
                  <v-list-item
                    v-if="hasPermission(action.permission)"
                    :key="i"
                    :href="action.route"
                    @click="action.onClick"
                  >
                    <v-icon small left>{{ action.icon }}</v-icon>
                    <v-list-item-title>{{ action.title }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <student-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :student="deleteDialog.item"
      @delete="getListData"
    >
    </student-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import StudentDeleteDialog from '@components/Student/DeleteDialog'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'Student',
  components: {
    StudentDeleteDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      headers: [
        { text: 'ID', value: 'code' },
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email', sortable: false },
        // { text: 'Gender', value: 'gender', sortable: false },
        { text: 'Date of Birth', value: 'date_of_birth', sortable: false },
        { text: 'Phone Number', value: 'phone_number', sortable: false },
        { text: 'Enrollment', value: 'enrollment', sortable: false },
        { text: 'Regis Date', value: 'registration_date', sortable: false },
        {
          text: 'Private Teachers',
          value: 'private_teachers',
          sortable: false,
        },
        { text: 'Status', value: 'status', sortable: false, align: 'center' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        code: null,
        name: null,
        email: null,
        gender: null,
        status: null,
        date_of_birth: [],
        private_teacher_id: null,
        registration_date: [],
        inactive_date: [],
        created_at: [],
        updated_at: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
      searchInputPrivateTeacher: null,
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'student/list',
      isLoading: 'student/isListLoading',
      listParams: 'student/listParams',
      privateTeachers: 'student/privateTeachers',
      isPrivateTeachersLoading: 'student/isPrivateTeachersLoading',
    }),
    genderOptions() {
      return constant.genderOptions
    },
    statusOptions() {
      return constant.studentStatusOptions
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
    searchInputPrivateTeacher(val) {
      if (val) {
        this.debouncedSearchPrivateTeachers()
      }
    },
  },
  created() {
    this.init()
    this.debouncedSearchPrivateTeachers = _.debounce(
      this.searchPrivateTeachers,
      500
    )
  },
  methods: {
    ...mapActions({
      getItemList: 'student/getList',
      getPrivateTeachers: 'student/getPrivateTeachers',
    }),
    ...mapMutations({
      setListParams: 'student/setListParams',
    }),
    async init() {
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
      }
    },
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
    async searchPrivateTeachers() {
      await this.getPrivateTeachers({
        search: this.searchInputPrivateTeacher,
        filters: {
          status: 'ACTIVE',
        },
      })
    },
    generateRowActions(item) {
      return [
        // {
        //   permission: 'invoices.view',
        //   route: this.$route('invoices.download-pdf', item.id),
        //   onClick: () => {},
        //   title: 'Download',
        //   icon: 'mdi-cloud-download',
        // },
        {
          permission: 'students.view',
          route: this.$route('students.detail', item.id),
          onClick: () => {},
          title: 'View Detail',
          icon: 'mdi-eye',
        },
        {
          permission: 'students.update',
          route: this.$route('students.update', item.id),
          onClick: () => {},
          title: 'Edit',
          icon: 'mdi-pencil',
        },
        // {
        //   permission: 'invoices.delete',
        //   route: null,
        //   onClick: () => this.showDeleteDialog(item),
        //   title: 'Delete',
        //   icon: 'mdi-delete-forever',
        // },
      ]
    },
  },
}
</script>
